import { apiCall } from "@/shared/services/apiCall";
import { errorToast, successToast } from "@/shared/services/helper.js";

const resetWithdrawalPassword = async (data) => {
    try{
        let response = await apiCall('post', 'RESET_WITHDRAWAL_PASSWORD', data, 'wallet')
        if (!response?.data?.success) {
            errorToast(response?.data?.message);
            return {error : response?.data?.message }
        }else{
            successToast(response?.data?.message);
            return true
        } 
    }catch(error){
        errorToast(error);
        console.log(error)
        return {error}
    }
};

export {
    resetWithdrawalPassword
}